export default {
    methods: {
        findWithAttrPro(array, attr, value, attr2, value2, op) {

            if(op === 'and'){
                for(var i = 0; i < array.length; i += 1) {
                    if(array[i][attr] === value && array[i][attr2] === value2) {
                        return i;
                    }
                }
                return -1;
            }
        },        
    }
}